function pdfViewer(file, base_url) {

	const BASEURL__ = setBaseUrl(base_url);
	const url = file.url;

	// The workerSrc property shall be specified.
	pdfjsLib.GlobalWorkerOptions.workerSrc = `${BASEURL__}/assets/js/pdf.worker.js`;

	let pdfDoc = null,
		pageNum = 1,
		pageIsRendering = false,
		pageNumIsPending = null;
	
	const scale = 1.5,
		canvas = document.querySelector(`#${file.id_canvas}`),
		ctx = canvas.getContext('2d');
	
	
	/**
	 * Render the page
	 * @param {int} num 
	 */
	const renderPage = function (num) {
		
		pageIsRendering = true;

		// Get page
		pdfDoc.getPage(num).then(function (page) {
			
			// Set scale
			const viewport = page.getViewport({ scale: scale });
			canvas.height = viewport.height;
			canvas.width = viewport.width;

			const renderCtx = {
				canvasContext: ctx,
				viewport: viewport
			};

			page.render(renderCtx).promise.then(function () {
				
				pageIsRendering = false;

				if (pageNumIsPending !== null) {
					renderPage(pageNumIsPending);
					pageNumIsPending = null;
				}

			});

			// Output current page
			document.querySelector(`#${file.id_page_num}`).textContent = num;

		});

	}

	
	/**
	 * Check for pages rendering
	 * @param {int} num 
	 */
	const queueRenderPage = function (num) {

		if (pageIsRendering) {
			pageNumIsPending = num;
		} else {
			renderPage(num);
		}

	}


	/**
	 * Show Prev Page
	 * @returns
	 */
	const showPrevPage = function () {

		if (pageNum <= 1) {
			return;
		}

		pageNum--;
		queueRenderPage(pageNum);

	}


	/**
	 * Show Next Page
	 * @returns
	 */
	const showNextPage = function () {

		if (pageNum >= pdfDoc.numPages) {
			return;
		}

		pageNum++;
		queueRenderPage(pageNum);

	}
	

	/**
	 * Get Document
	 */
	pdfjsLib.getDocument(url).promise.then(function (pdfDoc_) {
		
		pdfDoc = pdfDoc_;
		
		document.querySelector(`#${file.id_page_count}`).textContent = pdfDoc.numPages;

		renderPage(pageNum);

	});


	/**
	 * Button Events
	 */
	document.querySelector(`#${file.id_button_prev}`).addEventListener('click', showPrevPage);
	document.querySelector(`#${file.id_button_next}`).addEventListener('click', showNextPage);

}